export const TYPE_MENU = {
  MENU1: 'Food Local Seashell',
  MENU2: 'SQUID',
  MENU3: 'TIGER PRAWN',
  MENU4: 'PRAWN',
  MENU5: 'LOBSTER',
  MENU6: 'FISH',
  MENU7: 'CRABS',
};
export const LOCAL_STORAGE = {
  LANGUAGE: 'language',
};

export const LANGUAGE: { [key: string]: { code: string; name: string; shortName: string } } = {
  ENGLISH: { code: 'en', name: 'English', shortName: 'EN' },
  VIETNAMESE: { code: 'vi', name: 'Vietnamese', shortName: 'VI' },
};
